import {CouponJson} from "../../model/coupons/CouponJson";
import {httpClient, utilService} from "../../service";
import parse from "html-react-parser";
import {Button} from "react-bootstrap";
import React, {useState} from "react";
import {HttpMethod} from "../../model";
//import QRCode from "react-qr-code";
import ReactDOM from "react-dom";
import {getSessionCustNo} from './VerifyConfigModel';
import QRCode from 'qrcode.react';
const CouponVerifyListDetail = (props: any) => {
    const item: CouponJson = props.item;
    const index: number = props.index;
    const [couponInfo, setCouponInfo] = useState<string>('');
    const expireDate = utilService.convertDate(item.expireDate).format('YYYY.MM.DD');
    const desp = utilService.convertTextarea(item.desp);
    const [loading, setLoading] = useState<boolean>(false);
    const setData = (list: CouponJson[]) => {
        let couponStr = '발급쿠폰이 없습니다.';
        if (list) {
            if (list.length > 0) {
                couponStr = '<div class="coupon-info-box">';
                list.map((item, i) => {
                    const expireDate = utilService.convertDate(item.expireDate).format('YYYY.MM.DD');
                    const desp = utilService.convertTextarea(item.desp);
                    const createDate = utilService.convertDateTime(item.createDate).format('YYYY.MM.DD HH:mm:ss');
                    couponStr += '<ul>';
                    couponStr += `<li>발급회원:${item.custNo}</li>`;
                    couponStr += `<li>발급일시:${createDate}</li>`;
                    couponStr += `<li>쿠폰혜택:${item.name}</li>`;
                    couponStr += `<li>유효기간:${expireDate}</li>`;
                    couponStr += `<li>쿠폰내용:${desp}</li>`;
                    couponStr += '</ul>';
                });
                couponStr += '</div>';
            }
        }
        return couponStr;
    }
    const qrTd = 'qrtd_' + item.id.toString();
    const qrDiv = 'qrdiv_' + item.id.toString();
    const verifyClick = async (e: any) => {
        e.preventDefault();
        const obj = e.target;
        const custNo = getSessionCustNo();
        console.log(`click button id=${e.target}`);
        if (!(custNo !== undefined && custNo.length > 2)) {
            alert('기본환경설정을 먼저 하셔야 합니다.');
            return false;
        }
        const qrId = document.getElementById(qrTd);
        if (qrId) {
            qrId.innerText = '';
        }
        setLoading(true);
        const url = `test/verifications/coupon/issued/${item.id}/${custNo}`;
        const options = {
            method: HttpMethod.GET,
            url
        }
        const act = await httpClient(options);
        setLoading(false);

        if (act.result) {
            setCouponInfo(setData(act.data));
        } else {
            alert(act.errorMsg);
        }
    }
    const qrCodeClick = (e: any) => {
        e.preventDefault();
        let id = document.getElementById(qrDiv);
        const qrId = document.getElementById(qrTd);
        if (qrId == null) return;
        if (id != null) {
            id.remove();
            return;
        }
        setCouponInfo('');
        let tag = document.createElement("div");
        tag.setAttribute("id", qrDiv);
        qrId.appendChild(tag);
        id = document.getElementById(qrDiv);
        console.log(`qrcode couponId=${item.id}`);
        ReactDOM.render(<QRCode value={`qrIssue_${getSessionCustNo()}_${item.id.toString()}`} includeMargin={true}/>, id);
    }
    return (
        <>
            <tr>
                <td className="align-center">{index + 1}</td>
                <td className="align-center">{item.id}</td>
                <td>[{item.shop?.name}]<br/>{item.name}</td>
                <td className="align-center">{expireDate}</td>
                <td>{parse(desp)}</td>
                <td className="align-center">
                    <Button className="btn-secondary" size="sm" onClick={qrCodeClick} disabled={loading}
                            style={{width: '80px', marginBottom: '10px'}}>QR스캔</Button>
                    <Button className="btn-primary" size="sm" onClick={verifyClick} disabled={loading}
                            style={{width: '80px'}}>검증하기</Button>
                </td>
                <td>
                    <div id={qrTd}></div>
                    {parse(couponInfo)}
                </td>
            </tr>

        </>
    )
}
export default CouponVerifyListDetail;
